/* eslint-disable no-unused-vars */

import { mapActions } from 'vuex';
import { withMeta } from '@/helpers/dataLayer';
import log from '@/logger';
import loaderMixin from '@/mixins/loader';

const searchMixin = {
  mixins: [loaderMixin],
  methods: {
    ...mapActions('search', ['toggleSearchBar', 'getSearch', 'resetSearchResults']),
    ...mapActions('app', ['closeMobileMenu']),
    onSearchResults(data) {
      this.closeMobileMenu();
    },
    formatQuery(query) {
      return query.trim();
    },
    doSearch(query, options = { reset: true }) {
      if (this.isLoading) return;
      this.loaderAddLegacy(document.body);
      if (options.reset) {
        this.resetSearchResults(query);
      }

      this.getSearch(this.formatQuery(query))
        .then((data) => {
          this.loaderRemoveLegacy(document.body);
          this.$gtm.trackEvent(
            withMeta({
              event: 'Search',
              SearchNumTotalMarketsFound: data.totalMarkets,
            }),
          );
          this.onSearchResults(data);

          if (this.$route.query.query !== query) {
            this.$router.push({
              name: 'market-search',
              query: {
                query,
              },
            });
          }
        })
        .catch((error) => {
          log.error('Search failed.', error);
          this.loaderRemoveLegacy(document.body);
        });
    },
  },
};

export default searchMixin;
